// extracted by mini-css-extract-plugin
export default {"main":"WDqF6","sectionHeader":"Vlet8","invoiceCount":"MwGyJ","title":"VMN2O"};